import React, { useState, useMemo, useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Button from "../Elements/Button"
import Accordion from "../Accordion"

import {
  ServiceAreasContainer,
  ServiceAreasBackground,
  Header,
  Arrow,
  List,
  AreasList,
  LocationsList,
  AreaContainer,
  ImageWrapper,
  AreaLabel,
  LocationWrapper,
  LocationLabel,
  LocationIcon,
  HeaderSection,
  HeaderLeft,
} from "./index.style"
import { Container } from "../../styles/Common"
import { CustomModal } from "../CustomModal"
import { Form } from "../Form"

const AreaCard = ({ data, locationIcon, active, ...props }) => {
  return (
    <AreaContainer active={active} {...props}>
      <ImageWrapper size="medium">
        <div
          dangerouslySetInnerHTML={{ __html: locationIcon }}
          alt="location"
          className="pivot"
        />
      </ImageWrapper>
      <AreaLabel active={active}>{data.label}</AreaLabel>
    </AreaContainer>
  )
}

const LocationListOnAccordion = ({ locations }) => {
  return <LocationsList dangerouslySetInnerHTML={{ __html: locations }} />
}

const ListWithAccordion = ({ data, locationIcon }) => {
  const accordionData = useMemo(
    () =>
      (data || []).map(area => ({
        renderHeader: props => (
          <AreaCard data={area} locationIcon={locationIcon} {...props} />
        ),
        renderContent: () => (
          <LocationListOnAccordion
            locations={area.locations}
            locationIcon={locationIcon}
          />
        ),
      })),
    [data, locationIcon]
  )

  return (
    <Accordion
      data={accordionData}
      activeArrowStyle={{ right: 18, color: "#fff" }}
      inActiveArrowStyle={{ right: 18, color: "#010101" }}
    />
  )
}

const ServiceAreas = ({ data, buttonText, formData }) => {
  const [selectedArea, setSelectedArea] = useState(0)
  const [selectedLoc, setSelectedLoc] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const selectedLocations = useMemo(() => {
    return data.serviceAreas?.[selectedArea]?.locations ?? []
  }, [selectedArea, data])

  useEffect(() => {
    setSelectedLoc(0)
  }, [selectedArea])

  return (
    <ServiceAreasContainer>
      <ServiceAreasBackground>
        <GatsbyImage
          image={data.mapUrlDesktop}
          alt="service areas"
          className="background-desktop"
        />
        <GatsbyImage
          image={data.mapUrlMobile}
          alt="service areas"
          className="background-mobile"
        />
      </ServiceAreasBackground>
      <Container>
        <HeaderSection>
          <HeaderLeft>
            <Header>{data.heading}</Header>
            <Arrow />
          </HeaderLeft>
          <Button
            type="primary"
            className="request-btn"
            onClick={() => setIsModalOpen(true)}
          >
            {buttonText.buttonText}
          </Button>
        </HeaderSection>
        <List>
          <AreasList>
            {(data.serviceAreas || []).map((area, index) => (
              <AreaCard
                key={index}
                data={area}
                active={selectedArea === index}
                locationIcon={data.locationIcon}
                onClick={() => setSelectedArea(index)}
              />
            ))}
          </AreasList>

          <LocationsList
            dangerouslySetInnerHTML={{
              __html: data.serviceAreas[selectedArea].locations,
            }}
          />
        </List>
        <div className="accordion-content">
          <ListWithAccordion
            data={data.serviceAreas}
            locationIcon={data.locationIcon}
          />
        </div>
      </Container>
      <LocationIcon dangerouslySetInnerHTML={{ __html: data.locationIcon }} />
      <CustomModal
        onClose={() => setIsModalOpen(false)}
        isModalOpen={isModalOpen}
        modalContent={<Form data={formData} />}
      />
    </ServiceAreasContainer>
  )
}

export default ServiceAreas
